import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large DeliveryModal",
    title: "Закрытие доставки",
    loading: _ctx.state.is_loading,
    "confirm-button-text": "Закрыть доставку",
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.approveDelivery
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        placeholder: "Имя получателя",
        value: _ctx.state.receiver_name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.receiver_name) = $event)),
        "is-invalid": _ctx.state_form$.receiver_name.$error,
        "validation-errors": _ctx.state_form$.receiver_name.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_file_reader, {
        class: "mt-3",
        placeholder: "Приложения",
        value: _ctx.state.files,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.files) = $event)),
        multiple: "",
        "is-invalid": _ctx.state_form$.files.$error,
        "validation-errors": _ctx.state_form$.files.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}